// helpers
const UK_NAMES = new Set([
  'United Kingdom','UK','U.K.','Great Britain','GB','GBR','Britain','England','Scotland','Wales','Northern Ireland'
]);

function looksLikeUkPostcode(pc) {
  if (!pc) return false;
  const s = pc.trim().toUpperCase();
  // Loose but safe UK postcode regex (incl. special cases)
  const re = /^([A-Z]{1,2}\d[A-Z\d]?)\s*\d[A-Z]{2}$/;
  return re.test(s) || s === 'GIR 0AA' || s === 'GIR0AA';
}

function normaliseCounty(county) {
  if (!county) return '';
  const c = county.trim();
  if (/^bucks?$/i.test(c)) return 'Buckinghamshire';
  return c;
}

async function geocodeUKPostcode(postcode) {
  // postcodes.io accepts with/without space
  const pc = postcode.replace(/\s+/g, '');
  const r = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(pc)}`);
  const j = await r.json();
  if (j.status !== 200 || !j.result) throw new Error('Postcode lookup failed');
  return { lat: j.result.latitude, lng: j.result.longitude, provider: 'postcodes.io' };
}

async function geocodeNominatimStructured({ street, city, county, postcode, country, countryIsUK }) {
  const params = new URLSearchParams({
    format: 'json',
    limit: '1',
  });
  if (street)    params.set('street', street);
  if (city)      params.set('city', city);
  if (county)    params.set('county', county);
  if (postcode)  params.set('postalcode', postcode);
  if (country)   params.set('country', country);
  if (countryIsUK) params.set('countrycodes', 'gb');

  const url = `https://nominatim.openstreetmap.org/search?${params.toString()}`;
  const res = await fetch(url, { headers: { /* Referer is set by browser; UA is browser UA */ }});
  const data = await res.json();
  if (!Array.isArray(data) || data.length === 0) throw new Error('No match');
  return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon), provider: 'nominatim-structured' };
}

async function geocodeNominatimFreeText(q, countryIsUK) {
  const params = new URLSearchParams({
    q,
    format: 'json',
    limit: '1',
  });
  if (countryIsUK) params.set('countrycodes', 'gb');

  const res = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`);
  const data = await res.json();
  if (!Array.isArray(data) || data.length === 0) throw new Error('No match');
  return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon), provider: 'nominatim-free' };
}

async function geocodeAddress({ street, city, stateProvince, postcode, country }) {
  const countryIsUK = UK_NAMES.has((country || '').trim());

  // 1) Fast path for UK: postcode lookup
  if (countryIsUK && looksLikeUkPostcode(postcode)) {
    try { return await geocodeUKPostcode(postcode); } catch (_) {}
  }

  // 2) Structured Nominatim (with normalised county)
  const county = normaliseCounty(stateProvince);
  try {
    return await geocodeNominatimStructured({
      street, city, county, postcode, country, countryIsUK
    });
  } catch (_) {}

  // 3) Free-text fallback(s)
  const parts = [street, city, county, postcode, country].filter(Boolean).join(', ');
  try { return await geocodeNominatimFreeText(parts, countryIsUK); } catch (_) {}

  // 4) Final UK fallback: postcode-only then city+country
  if (countryIsUK && postcode) {
    try { return await geocodeNominatimFreeText(`${postcode}, ${country}`, countryIsUK); } catch (_) {}
  }
  if (city && country) {
    try { return await geocodeNominatimFreeText(`${city}, ${country}`, countryIsUK); } catch (_) {}
  }

  throw new Error('Geocoding failed');
}

export {
  geocodeAddress,
  looksLikeUkPostcode, // optional, handy for inline validation

};

